export default __webpack_public_path__ + "static/media/teacher.88c85540.png";